<template>
  <div>
    GOAL: {{ bendGoal}}
    <hr />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Bend_PlanRow",
  components: {
  },
  props: {
    resource: {
      type: Object,
      default: ()=>{return {}},
      required: true
    },
    bend: {
      type: Object,
      default: ()=>{return {}},
      required: true
    }
  },
  created() {

  },
  computed: {
    ...mapGetters({
      profile: "user/profile",
      userData: "user/appsData"
    }),
    bendPlan(){
      return this.bend.plan &&  this.bend.plan.message &&  this.bend.plan.message.content ?
          JSON.parse(this.bend.plan.message.content) : {}
    },
    bendGoal(){
      return this.bendPlan.workout_plan && this.bendPlan.workout_plan.goal ?
          this.bendPlan.workout_plan.goal :'';
    },
    createdBy(){
      return this.bendPlan.workout_plan && this.bendPlan.workout_plan.goal ?
          this.bendPlan.workout_plan.goal :'';
    }
  },
  methods: {},
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped></style>
